import {
  ActivatedRouteSnapshot,
  CanMatchFn,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from "@angular/router";
import { inject } from "@angular/core";
import { IsLoggedInUseCase } from "@app/core/shared/domain/is-logged-in.use-case";
import { RoutesSlugs } from "@app/routes-slugs";
import { RedirectUrlService } from "@app/presentation/services/redirectUrl.service";

export const loggedInUserGuard: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
) => {
  // Skip auth for routes marked as public (e.g. match-example)
  if ((route as any)?.data?.["public"] === true) {
    return true;
  }

  const isLoggedIn = inject(IsLoggedInUseCase).execute();

  //const pathWithoutHostname = segments.map((segment) => segment.path).join("/");

  // If the user is logged in, then allow the route to match.
  // Otherwise, redirect to the login page.
  if (!isLoggedIn) {
    const currentPath = (segments as unknown as RouterStateSnapshot).url;
    const redirectUrlService = inject(RedirectUrlService);
    redirectUrlService.saveRedirectUrl(currentPath);
    inject(Router).navigate(["/", RoutesSlugs.LOGIN], { replaceUrl: true });
  }

  return true;
};
